<template lang="pug">
.auth-page
    .left
        .logo
        .login-container
            .background-rectangle
            .input-container
                input.username(type="text" v-model="email" placeholder="Email")
                PasswordInput.password(type="text" v-model="password" placeholder="Password" :allow-show="true")
        .error(v-if="error") Error: {{error}}
        .btn-container
            button.g-outline-2.login(@click="login") Login


    .right

</template>
<script lang="ts" setup>
import { useAuth } from '../store/auth'
import PasswordInput from "../components/password.vue"
import { ref } from 'vue'
import { router } from '../router'

const email = ref<string>('')
const password = ref<string>('')
const error = ref<null | string>(null);
const auth = useAuth();

const login = async() =>{
    error.value = null

    try{
        const response = await auth.signIn(email.value, password.value)

        if(response.success){
            router.push('/')
        }else{
            error.value = response.reason
        }
    }catch(e) {
        if(typeof e === 'string'){
            error.value = e
        }else{
            error.value = e.message
        }
    }
}

</script>

<style lang="scss">
.auth-page{
    width: 100%;
    height: 100%;
    display:flex;
    margin: unset;
    padding: unset;
    overflow: hidden;

    .left{
        width:50%;
        height:100%;
        background: black;
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .logo{
            position:absolute;
            top:5%;
            left:2%;
            width:12.5%;
            height: 12.5%;
            min-width: 175px;
            background-image: url('../resources/images/Canine-Revolution-Logo-white-1.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }
        .login-container{
            width: 75%;
            position: relative;
            margin-bottom:5%;

            .background-rectangle{
                position: absolute;
                left:0;
                z-index:2;
                height:75%;
                background:#333333;
                border: 1px solid white;
                width:70%;
            }
            .input-container{
                // position:absolute;
                margin-top:1rem;
                display:flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                z-index:3;
                width:100%;
                height:100%;
                .username,
                .password{
                    font-size: 1rem;
                    padding: 1rem;
                    z-index:3;
                    width: 65%;
                    min-height: 30px;
                    background:white;
                }
                .username{
                    margin-bottom:2rem;
                }
            }
        }
        .error{
            color: red;
        }
        .btn-container{
            margin-top:2rem;
            width:100%;
            display: flex;
            justify-content: center;
            .login{
                height: 45px;
                width: 130px;
            }
        }

    }
    .right{
        width:50%;
        height:100%;
        background-image: url('../resources/doge.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

    }
}
</style>